import { render, staticRenderFns } from "./response-details.vue?vue&type=template&id=06b6894a"
import script from "./response-details.vue?vue&type=script&lang=js"
export * from "./response-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports